import DOMPurify from "isomorphic-dompurify";

export const customSanitize = (html: string | Node) => {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ["target", "rel", "allowfullscreen", "allow"],
    ADD_TAGS: ["iframe"],
  });
};
export const sanitizeTitle = (html: string | Node) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [], // No tags allowed
    ALLOWED_ATTR: [], // No attributes allowed
  });
};

export const sanitizeAndStyleParagraph = (
  html: string | Node,
  className: string,
) => {
  // 1. Add the hook
  DOMPurify.addHook("afterSanitizeAttributes", function (node) {
    if (node.tagName === "P") {
      node.classList.add(className); // Your desired class
    }
  });

  // 2. Sanitize the string
  const cleanHTML = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "ul", "li", "a"],
    ALLOWED_ATTR: ["class"],
  });

  // 3. Clean up the hook immediately
  DOMPurify.removeHook("afterSanitizeAttributes");

  return cleanHTML;
};
